/**
 * Reviews By Location Select functionality.
 * Redirects user to selected location's reviews page.
 */

const selectElement: HTMLSelectElement | null = document.querySelector(
	'[name=reviews-by-location-select]'
);

if (selectElement) {
	selectElement.addEventListener('change', function () {
		const selectedValue = this.value;

		// Only redirect if a valid option is selected (not the default "Select a Location")
		if (selectedValue && selectedValue !== '') {
			window.location.href = selectedValue;
		}
	});
}
